import MiniMasonry from 'minimasonry';
window.MiniMasonry = MiniMasonry;